import React from "react";
import { Route } from "react-router-dom";
import { DistributionMergingCard } from "./MergingCard";
import { DistributionMergingUIProvider } from "./MergingUIContext";
import { PrivateRoute } from "../../../../PrivateRoute";
import { RoleChecker } from "../../../../RoleChecker";

export function DistributionMergingPage({ history }) {
  const distributionMergingUIEvents = {
    newDistributionMergingIndividuButtonClick: () => {
      history.push("/kurban/distribution/merging/individual/new");
    },
    newDistributionMergingOrganizationButtonClick: () => {
      history.push("/kurban/distribution/merging/organization/new");
    },
    openEditDistributionMergingIndividualPage: (id) => {
      history.push(`/kurban/distribution/merging/individual/${id}/edit`);
    },
    openEditDistributionMergingOrganizationPage: (id) => {
      history.push(`/kurban/distribution/merging/organization/${id}/edit`);
    },
    openDeleteDistributionMergingPage: (id) => {
      history.push(`/kurban/distribution/merging/${id}/delete`);
    },
  };

  return (
    <DistributionMergingUIProvider
      distributionMergingUIEvents={distributionMergingUIEvents}
    >
      <DistributionMergingCard history={history} />
    </DistributionMergingUIProvider>
  );
}
